module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.controller,
      "fields": _vm.fields,
      "model": "controllers",
      "buttons": _vm.buttons,
      "cancel": false,
      "ignoreEntityChanges": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ccf2e94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controller/ControllerForm.vue
// module id = 1007
// module chunks = 2